// The single place that decides how a visitor books a spot.
//
// Today every event sends people to an external ticket page (currently the
// Always Summer shop). When we start selling tickets ourselves, this is the
// only component that has to change: swap the link for a Stripe Checkout call
// using event.price / event.currency, and add the Stripe fields to the event
// schema in thepinewoods-studio.
function BookingButton({ event }) {
  if (event.soldOut) {
    return <p className="event-sold-out">This event is sold out.</p>;
  }

  if (!event.ticketUrl) return null;

  return (
    <a
      className="event-book-button"
      href={event.ticketUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      {event.ticketLabel || 'Book your spot'}
    </a>
  );
}

export default BookingButton;
